/* global axios */

import ApiClient from './ApiClient';

class DisparosAPI extends ApiClient {
  constructor() {
    super('disparos', { accountScoped: true });
  }

  years() {
    return axios.get(`${this.url}/dividas/years`);
  }

  byYear(year) {
    return axios.get(`${this.url}/dividas`, { params: { year } });
  }

  search(term) {
    return axios.get(`${this.url}/dividas`, { params: { search: term } });
  }

  dispatch(codDivPars, template) {
    return axios.post(`${this.url}/dividas/dispatch_disparo`, {
      cod_div_pars: codDivPars,
      template,
    });
  }
}

export default new DisparosAPI();
